export default "__VITE_ASSET__$XOUQEOj__"